import { en } from "@/constants/locales/en";
import { es } from "@/constants/locales/es";
export default defineI18nConfig(() => ({
  legacy: false,
  locale: "en",
  messages: {
    en: en,
    es: es,
  },
}));
